import React, { useEffect, useState } from 'react';
import { ExperimentReportsDialogue } from './ExperimentReportsDialogue';
import ExperimentService from 'business/services/ExperimentService';
import { LoadingModal } from 'components/modal';
import { GetPlatePadding } from 'utils/Global';

interface Props {
  reportType: string;
  setReportType: (e: string) => void;
  expId: number;
  onPopupBlocked?: () => void;
}

export const ExperimentReportDialogueWrapper = ({
  reportType,
  setReportType,
  expId,
  onPopupBlocked,
}: Props) => {
  const [expData, setExpData] = useState(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    const fetchExperimentData = async () => {
      const experimentService = new ExperimentService();
      setIsLoading(true);
      const expData = await experimentService.getExperimentService(expId);
      if (expData === null) {
        return;
      }
      setExpData(expData);
      setIsLoading(false);
    };

    if (expId) {
      fetchExperimentData();
    }
  }, [expId]);

  return (
    <>
      {expData && (
        <ExperimentReportsDialogue
          selectedWell={expData?.wellDetails}
          reportType={reportType}
          setReportType={setReportType}
          canvasRef={null}
          docData={expData}
          platePadding={GetPlatePadding()}
          onPopupBlocked={onPopupBlocked}
        />
      )}
      <LoadingModal showModal={isLoading} text={'Loading...'} />
    </>
  );
};

export default ExperimentReportDialogueWrapper;
